/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Submit_FailedInputs */

const vi_einvoice_submit_failed = /** @type {(inputs: Einvoice_Submit_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất HĐĐT thất bại`)
};

/**

* @param {Einvoice_Submit_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_submit_failed = /** @type {((inputs?: Einvoice_Submit_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Submit_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_submit_failed(inputs)
});